
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.024 7.424c0 1.667-1.362 3.004-3.061 3.004-1.699 0-3.061-1.337-3.061-3.004 0-1.668 1.362-3.005 3.061-3.005 1.699 0 3.061 1.337 3.061 3.005zM5.337 13.843c0-1.544 2.117-1.944 4.626-1.944 2.495 0 4.626.386 4.626 1.931 0 1.544-2.117 1.944-4.626 1.944-2.495 0-4.626-.386-4.626-1.93zM16.61 8.123c.44-1.687-.85-3.202-2.49-3.202-.18 0-.35.02-.516.052-.022.005-.047.016-.06.035-.015.024-.004.057.012.078.493.679.776 1.505.776 2.392 0 .85-.26 1.642-.715 2.3-.047.068-.006.16.077.173.115.02.232.03.352.033 1.195.031 2.267-.724 2.564-1.86zM16.311 11.17c.803.155 1.331.468 1.55.926.185.375.185.81 0 1.185-.334.709-1.413.936-1.833.995a.13.13 0 01-.147-.146c.214-1.964-1.49-2.895-1.93-3.109-.02-.01-.024-.025-.022-.034.002-.006.01-.016.024-.018.954-.017 1.98.11 2.358.202zM6.396 4.973a2.617 2.617 0 00-.515-.052c-1.641 0-2.93 1.515-2.49 3.203.296 1.137 1.368 1.891 2.563 1.86a2.53 2.53 0 00.352-.033c.083-.014.124-.105.077-.173a4.021 4.021 0 01-.715-2.3c0-.888.284-1.714.777-2.392.015-.021.027-.054.011-.078-.013-.02-.037-.03-.06-.035zM2.14 12.096c.218-.458.746-.772 1.549-.926.38-.09 1.404-.218 2.359-.2.014 0 .021.01.023.017.002.01-.002.024-.02.034-.442.214-2.146 1.146-1.932 3.109a.13.13 0 01-.147.146c-.419-.059-1.498-.287-1.833-.995a1.332 1.332 0 010-1.185z","fill":"#94A3B8"}})])
          )
        }
      }
    